import {
  LIST_IDS,
  SET_COMMON_ACTION,
  SET_DATE_FIELD_ACTION,
  SET_SIMPLE_VALIDAR_PROCESSO_ACTION,
} from './ValidarProcesso.constants';

function buildRequestFields() {
  return {
  };
}

function buildInitialStates() {
  return {
    requestFields: buildRequestFields(),
    page: 0,
    rowsPerPage: 10,
    totalElements: 0,
    columnOrdenacao: { element: 'idProcesso', order: 'DESC' },
    arrowDirection: true,
    tableView: [],
    selectAll: false,
    listIds: {},
    atualizarListaIds: false,
    common: {
      loadingPage: false,
    },
  };
}

function onChangeDateFieldHandler(states, actions) {
  const { name, value } = actions;
  const field = states.requestFields[name].getNewModel(value);

  return {
    ...states,
    requestFields: {
      ...states.requestFields,
      [name]: field,
    },
  };
}

function setSimpleValidarProcessoHandler(states, actions) {
  const { name, value } = actions;
  return {
    ...states,
    [name]: value,
  };
}

function setCommonHandler(states, actions) {
  const { name, value } = actions;
  return {
    ...states,
    common: {
      ...states.common,
      [name]: value,
    },
  };
}

function setSimpleValuesListIdsHandler(states, actions) {
  const { name, value } = actions;
  return {
    ...states,
    listIds: {
      ...states.listIds,
      [name]: value,
    },
  };
}

export const onChangeDateFieldAction = (name, value) => ({
  type: SET_DATE_FIELD_ACTION,
  name,
  value,
});

export const setSimpleValidarProcessoAction = (name, value) => ({
  type: SET_SIMPLE_VALIDAR_PROCESSO_ACTION,
  name,
  value,
});

export const setCommonAction = (name, value) => ({
  type: SET_COMMON_ACTION,
  name,
  value,
});

export const setSimpleValuesListIdsAction = (name, value) => ({
  type: LIST_IDS,
  name,
  value,
});

export default (states = buildInitialStates(), actions) => {
  switch (actions.type) {
    case SET_DATE_FIELD_ACTION:
      return onChangeDateFieldHandler(states, actions);
    case SET_SIMPLE_VALIDAR_PROCESSO_ACTION:
      return setSimpleValidarProcessoHandler(states, actions);
    case SET_COMMON_ACTION:
      return setCommonHandler(states, actions);
    case LIST_IDS:
      return setSimpleValuesListIdsHandler(states, actions);
    default:
      return states;
  }
};
